import { Injectable, TemplateRef } from "@angular/core";
import { Subject } from 'rxjs';

import { LoginObserverService } from '../authentication/login-observer.service';

/**
 * This service is an in-memory state manager to help keep track of states across different pages.
 */
@Injectable({
    providedIn: 'root'
})
export class StateService {

    states: { [key: string]: any } = {};

    constructor(private loginObserverService: LoginObserverService) {

        // Subscribe to events that can have impact on the states - and clear the states on changes
        this.loginObserverService.loginObserver.subscribe(() => this.clearAllStates());
        this.loginObserverService.logoutObserver.subscribe(() => this.clearAllStates());
    }

    /**
     * Sets the state for the given key. Any state with the same key will be overwritten.
     * @param key The key for the state to save
     * @param stateObject The state-object to save
     */
    public setState(key: string, stateObject: any) {
        this.states[key] = stateObject;
    }

    /**
     * Gets the state for the given key.
     * @param key The key for the state to retrieve.
     * @return The state for the given key - undefined if no state found.
     */
    public getState(key: string): any {
        return this.states[key];
    }

    /**
     * Removes the state with the given key
     * @param key The key for the state to remove
     */
    public removeState(key: string) {
        delete this.states[key];
    }

    /**
     * Clear all the states
     */
    public clearAllStates() {
        this.states = { };
    }
}
